import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-support-login-callback',
  templateUrl: './support-login-callback.component.html',
  styleUrls: ['./support-login-callback.component.scss']
})
export default class SupportLoginCallbackComponent {
}
